import React, { type ReactNode } from "react";
import backgroundImage from "../images/bg3.webp";

export default function BackgroundHeader({ children, className }: { children: ReactNode, className?: string }): ReactNode {
  return (
    <section
      className={`flex-none m-0 flex justify-center bg-cover bg-center ${className || ''}`}
      style={{
        background:
          `linear-gradient(90deg, rgb(0 0 0 / 0.5), rgb(0 0 0 / 0.3)), url(${backgroundImage}) center / cover`,
      }}
    >{children}</section>
  );
}